import React, { useMemo } from 'react'
import { useTheme } from 'styled-components'
import styled from 'styled-components/native'

import { LayoutButtonProps } from 'features/search/types'
import { AccessibilityRole } from 'libs/accessibilityRole/accessibilityRole'
import { TouchableOpacity } from 'ui/components/TouchableOpacity'
import { ViewGap } from 'ui/components/ViewGap/ViewGap'
import { Checkmark } from 'ui/svg/icons/Checkmark'
import { Typo } from 'ui/theme'

export const LayoutButton = ({ isSelected, Icon, onPress, layout }: LayoutButtonProps) => {
  const { designSystem } = useTheme()

  const StyledIcon = useMemo(() => {
    return Icon
      ? styled(Icon).attrs(({ theme }) => ({
          color: isSelected
            ? theme.designSystem.color.icon.brandPrimary
            : theme.designSystem.color.icon.default,
          size: theme.designSystem.size.icon.s,
        }))``
      : null
  }, [Icon, isSelected])

  const accessibilityLabelChecked = isSelected ? 'sélectionné' : 'non sélectionné'
  const accessibilityLabel = `${layout} - ${accessibilityLabelChecked}`

  return (
    <TouchableOpacity
      id={layout}
      onPress={onPress}
      accessibilityRole={AccessibilityRole.BUTTON}
      accessibilityLabel={accessibilityLabel}>
      <TitleContainer gap={2} isSelected={isSelected}>
        {StyledIcon ? (
          <IconsContainer gap={2}>
            {isSelected ? <Checkmark color={designSystem.color.icon.brandPrimary} /> : null}
            <StyledIcon testID={`${layout}-icon`} />
          </IconsContainer>
        ) : null}
        {isSelected ? <Title isSelected={isSelected}>{layout}</Title> : null}
      </TitleContainer>
    </TouchableOpacity>
  )
}

const TitleContainer = styled(ViewGap)<{ isSelected: boolean }>(({ isSelected, theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: isSelected
    ? theme.designSystem.color.background.brandPrimarySelected
    : undefined,
  padding: theme.designSystem.size.spacing.s,
  borderRadius: theme.designSystem.size.borderRadius.m,
}))

const IconsContainer = styled(ViewGap)(({ theme }) => ({
  flexDirection: 'row',
  paddingVertical: theme.designSystem.size.spacing.s,
}))

const Title = styled(Typo.BodyAccent)<{ isSelected: boolean }>(({ isSelected, theme }) => ({
  color: isSelected
    ? theme.designSystem.color.text.brandPrimary
    : theme.designSystem.color.text.default,
}))
